









































































import { Component, Prop, Vue } from 'vue-property-decorator';
import CriteriaPreview from '@/components/CriteriaPreview.vue';
import AudienceSummary from '@/components/AudienceSummary.vue';
import AudienceCustomerDetails from '@/components/AudienceCustomerDetails.vue';
import AudienceHistory from '@/components/AudienceHistory.vue';
import AudienceAssociatedCampaigns from '@/components/AudienceAssociatedCampaigns.vue';
import { Action, Getter } from 'vuex-class';
const namespace: string = 'counter';
import router from '../router';
import BaseView from '../BaseView';
import { AudienceDetails } from '../models/AudienceDetails';
import { AudienceDetailsService } from '../services/AudienceDetailsService';
import { StatisticsPanelModel } from '../models/StatisticsPanelModel';
import { AudienceCampaign } from '../models/AudienceCampaign';
import StatisticsPanel from '@/components/StatisticsPanel.vue';
import {
    GenericModal,
    GenericModalType,
    GenericModalCancelLabel,
    GenericModalContinueLabel,
    GenericModalTitle,
    GenericModalOption,
    GenericModalResponse
} from '../models/GenericModal';
import AudienceGenericModal from '@/components/AudienceGenericModal.vue';

@Component({
    components: {
        CriteriaPreview,
        AudienceSummary,
        AudienceCustomerDetails,
        AudienceHistory,
        AudienceAssociatedCampaigns,
        StatisticsPanel,
        AudienceGenericModal
    },
})
export default class AudienceDetail extends BaseView {

    @Prop({ default: 0 })
    private audienceId!: number;

    @Prop({ default: 'LastSaved' })
    private detailType!: string;

    @Getter('currentCompanyId', { namespace })
    private companyId!: number;

    @Getter('currentClientId', { namespace })
    private clientId!: number;

    @Getter('audienceDetailName', { namespace: 'manageAudience' })
    private audienceDetailName!: string;

    private detailId: number = 0;
    private audienceName: string = '';
    private audienceNameDisplay: string = '';

    private componentsKey: number = 0;

    private audienceLastSavedDetails: AudienceDetails = new AudienceDetails();
    private audienceLastPublishedDetails: AudienceDetails = new AudienceDetails();
    private audienceDetailsService: AudienceDetailsService = new AudienceDetailsService(this.clientId);

    private showSummary: boolean = true;
    private showCustomerDetail: boolean = false;
    private showAssociatedCampaigns: boolean = false;
    private showHistory: boolean = false;
    private disableEditButton: boolean = true;

    private audienceCampaigns: AudienceCampaign[] = [];

    public created() {
        this.Init();
    }

    private mounted() {
        if (this.$route.query.campaigns && this.$route.query.campaigns === '1') {
            this.showSummary = false;
            this.showCustomerDetail = false;
            this.showHistory = false;
            this.showAssociatedCampaigns = true;
        }
        this.scrollToTop();
    }

    private showTab(tab: string) {
        this.showSummary = false;
        this.showCustomerDetail = false;
        this.showAssociatedCampaigns = false;
        this.showHistory = false;

        switch (tab) {
            case 'Summary':
                this.showSummary = true;
                break;
            case 'CustomerDetail':
                const customerDetails: any = this.$refs.customerDetailRef;
                customerDetails.InitAudienceSearchTable();
                this.showCustomerDetail = true;
                break;
            case 'AssociatedCampaigns':
                this.showAssociatedCampaigns = true;
                const campaigns: any = this.$refs.campaignsRef;
                break;
            case 'History':
                const historyComponent: any = this.$refs.audienceHistoryRef;
                historyComponent.InitAudienceHistoryTable();
                this.showHistory = true;
                break;
            default:
                this.showSummary = true;
                break;
        }
    }

    private goHome() {
        this.$router.push('/');
    }

    private Init() {
        // if audienceDetailName on vuex manageAudience
        // store exists display it, else wait until fetchAudienceDetails returns it.
        if (this.audienceDetailName && this.audienceDetailName.length > 0) {
            this.audienceName = this.audienceDetailName;
            this.audienceNameDisplay = this.audienceName.length > 50 ?
                        this.audienceName.substring(0, 50) + '...' :
                        this.audienceName;
        }
        // this.compareVersions();
        this.fetchAudienceDetails();
    }

    private fetchAudienceDetails() {
        const self = this;
        window.App.$axios.get(`/api/audience/api/v1.0/companyid/${this.clientId}/audience/${this.audienceId}/details?api_user=${window.eInsightUserEmail}`)
            .then((response) => {
                let details: AudienceDetails[] = [];
                details = this.audienceDetailsService.APIResponseToAudienceDetailsList(response);
                // set details for each type saved and published
                details.forEach((detail) => {
                    if (detail.AudienceDetailType === 'LastPublished') {
                        self.audienceLastPublishedDetails = detail;
                        if (detail.IsGenerating) {
                            self.checkStatisticsQuietly(detail.AudienceDetailsID, 'HidenStatisticPanelLastPublished');
                        }
                    } else if (detail.AudienceDetailType === 'LastSaved') {
                        self.audienceLastSavedDetails = detail;
                        self.disableEditButton = false;
                        if (detail.IsGenerating) {
                            self.checkStatisticsQuietly(detail.AudienceDetailsID, 'HidenStatisticPanelLastSaved');
                        }
                    }

                    self.audienceName = detail.Name;
                    self.audienceNameDisplay = detail.Name.length > 50 ?
                        detail.Name.substring(0, 50) + '...' :
                        detail.Name;
                });
                this.$nextTick(() => {
                    // gives time for bindings to be updated in child components
                    self.loadSummary();

                    window.App.$axios.get(`/api/audience/api/v1.0/companyid/${this.clientId}/audience/${this.audienceId}/campaigns?api_user=${window.eInsightUserEmail}`)
                        .then((response) => {
                            this.audienceCampaigns = this.audienceDetailsService.APIResponseToAudienceCampaignsList(response);
                            const summary: any = this.$refs.summaryRef;
                            summary.updateAssociatedCampaignsCount(this.audienceCampaigns);
                        });
                });
            });

        // window.App.$axios.get(`/api/audience/api/v1.0/companyid/${this.clientId}/audience/${this.audienceId}/campaigns?api_user=${window.eInsightUserEmail}`)
        //    .then((response) => {
        //        this.audienceCampaigns = this.audienceDetailsService.APIResponseToAudienceCampaignsList(response);
        //        const summary: any = this.$refs.summaryRef;
        //        summary.updateAssociatedCampaignsCount(this.audienceCampaigns);
        //    });
    }

    private loadSummary() {
        const self = this;
        this.componentsKey += 1;
        this.$nextTick(() => {
            self.compareVersions();
            const summary: any = this.$refs.summaryRef;
            summary.loadComponent();
        });
    }

    private openAddAudienceFullScreenModal() {
        const returnURL = encodeURI(this.$router.currentRoute.fullPath);
        this.$router.push({ path: `/audience/${this.audienceId}/edit/${this.audienceLastSavedDetails.AudienceDetailsID}?returnURL=${returnURL}`});
    }

    private compareVersions(): void {
        const path: string = `/api/audience/api/v1.0/companyid/${this.clientId}/audience/${this.audienceId}/compare?api_user=${window.eInsightUserEmail}`;
        window.App.$axios.get(path)
            .then((response) => {
                this.handleCompareSucessResponse(response);
            });
    }

    private handleCompareSucessResponse(response: any) {
        const areTheSame: boolean = response.data.data.sameAsLastSaved;
        const hasLastPublished: boolean = response.data.data.lastPublishedId > 0;
        // update toggles
        const summary: any = this.$refs.summaryRef;
        summary.setToggle(areTheSame, hasLastPublished);
        const customerDetailRef: any = this.$refs.customerDetailRef;
        customerDetailRef.setToggle(areTheSame, hasLastPublished);
    }

    private checkStatisticsQuietly(AudienceDetailsID: number, PanelLocation) {
        const target: HTMLElement | null = document.getElementById(PanelLocation);
        let statisticsPanel: any = this.$refs.lastPublishedstatisticsPanelRef;
        if (PanelLocation === 'HidenStatisticPanelLastSaved') {
            statisticsPanel = this.$refs.lastSavedStatisticsPanelRef;
        }
        const model: StatisticsPanelModel = new StatisticsPanelModel(
            this.clientId,
            AudienceDetailsID,
            target as HTMLElement,
            null,
            false,
            true,
            false);
        statisticsPanel.fetchStatistics(model);
    }

    private onStatisticsCompleted(data: any): void {
        this.showCountsCompletedPopup();
    }

    private showCountsCompletedPopup() {
        const message = `Audience counts are ready. Refresh the page?`;
        const popup = new GenericModal();
        popup.id = 'CountsCompletedRefesh';
        popup.cancelButton = GenericModalCancelLabel.No;
        popup.continueButton = GenericModalContinueLabel.Yes;
        popup.title = GenericModalTitle.Confirm;
        popup.message = message;
        this.showModal(popup);
    }

    private showModal(request: GenericModal) {
        const modal: any = this.$refs.genericModalref;
        modal.show(request);
    }

    private hideModal() {
        const modal: any = this.$refs.genericModalref;
        modal.hide();
    }

    private handleContinuePopup(response: GenericModalResponse) {
        switch (response.id) {
            case 'CountsCompletedRefesh': {
                this.Init();
                this.showTab('Summary');
                this.hideModal();
                break;
            }
            default: {
                break;
            }
        }
    }
}
